const useDocumentName = () => {
  const getName = (docName = "") => {
    const [ext, ...rest] = docName.split(".").reverse();
    return rest.reverse().toString();
  };
  return { getName };
};

export default useDocumentName;
